Pixlee.module('Behaviors', function(Behaviors, App, Backbone, Marionette, $) {

    Behaviors.RefreshOnCssGenerated = Marionette.Behavior.extend({
        onReloadSly: function() {
        	var _this = this;
        	setTimeout(function(){
	            _this.view.sly.reload();
        	}, 400);
        }
    });

});